module.exports = __webpack_public_path__ + "img/menu-recolhido.5fc38d6f.svg";